function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M214.768 20.7678C215.744 19.7915 215.744 18.2085 214.768 17.2322L198.858 1.32233C197.882 0.34602 196.299 0.34602 195.322 1.32233C194.346 2.29864 194.346 3.88155 195.322 4.85786L209.464 19L195.322 33.1421C194.346 34.1184 194.346 35.7014 195.322 36.6777C196.299 37.654 197.882 37.654 198.858 36.6777L214.768 20.7678ZM0 21.5H213V16.5H0V21.5Z",
  fill: "white"
});

var SvgArrowRightIcon = function SvgArrowRightIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 38,
    viewBox: "0 0 216 38",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowRightIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ArrowRightIcon.fa4f407b.svg";
export { ForwardRef as ReactComponent };